import React, {memo} from "react";
import clsx from "clsx";
import {useSelector} from "react-redux";
import {translations} from "@utils/translations";
import {IconCross} from "@searchComponents/icons";
import FilterCard from "./FilterCard";
import FilterCardSelect from "./FilterCardSelect";
import FilterCardSlider from "./FilterCardSlider";
import FilterCardDropdown from "./FilterCardDropdown";
import ResetButton from "./ResetButton";
import styles from "../../../styles/components/filters.module.scss";

const Filters = memo(({params = {}, resetHandler, closeFilter}) => {
    const appSettings = useSelector(({rootReducer}) => rootReducer.baseSettings);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";

    // eslint-disable-next-line no-unused-vars
    const translate = (s) => translations[lang][s] || s;

    return (
        <div
            className={`${styles.filter}`}>
            <div className={`${styles.top}`}>
                <div className={`${styles.close}`} onClick={closeFilter}>
                    <IconCross/>
                </div>
                <span className={`${styles.title}`}>
            {translate("filter")}
          </span>
                <span className={`${styles.reset}`}>
            <ResetButton resetHandler={resetHandler} className={`${styles.reset__btn}`}/>
          </span>
            </div>
            {Object.keys(params).map((item) => {
                switch (params[item].type) {
                    case "checkboxes": {
                        return (
                            <FilterCard
                                key={item}
                                parentValue={item}
                                title={params[item].label}
                                content={params[item].choices}
                                selected={params[item].selected.reduce((acc, cur) => {
                                    acc[cur] = cur;
                                    return acc;
                                }, {})}
                            />
                        );
                    }
                    case "search": {
                        return; // break;
                    }
                    case "dropdown": {
                        const selectedRename = [];
                        params[item].choices?.forEach((el) => (params[item].selected.includes(el.value) ? selectedRename.push({
                            label: el.label,
                            value: el.value,
                        }) : null));

                        return (
                            <FilterCardDropdown
                                key={item}
                                content={params[item].choices}
                                title={params[item].label}
                                parentValue={item}
                                selected={selectedRename}
                            />
                        );
                    }
                    case "fselect": {
                        const selectedRename = [];

                        // Allow renaming of labels depending on the item. (e.g. merged tags)
                        // Renaming values has been added as an option, but it is untested and requires additional logic to properly function.
                        const selectedRenameStrategy = () => {
                            switch (item) {
                                case 'type_car':
                                    return {
                                        label: (label) => label.replace('Monteur-', ''),
                                        value: (value) => value,
                                    };
                                default:
                                    return {
                                        label: (label) => label,
                                        value: (value) => value,
                                    };
                            }
                        };

                        const currentRenameStrategy = selectedRenameStrategy();

                        params[item].choices?.forEach((el) => {
                            el.label = currentRenameStrategy.label(el.label);
                            el.value = currentRenameStrategy.value(el.value);

                            (params[item].selected.includes(el.value)
                                && selectedRename.push({
                                    label: el.label,
                                    value: el.value,
                                })
                            );
                        });

                        return (
                            <FilterCardSelect
                                key={item}
                                content={params[item].choices}
                                title={params[item].label}
                                parentValue={item}
                                selected={selectedRename}
                                placeholder={translate(params[item].settings.placeholder) ?? params[item].label}
                            />
                        );
                    }
                    case "slider": {
                        const range = [0, 100];

                        return (
                            <FilterCardSlider
                                key={item}
                                min={range[0]}
                                max={range[1]}
                                step={Number(params[item].settings.step)}
                                title={params[item].label}
                                // value={[0,10000]}
                                value={params[item].selected.length === 0 ? range : params[item].selected.map((el) => Math.round(Number(el)))}
                                // value={params[item].settings.start.map((el) => Math.round(Number(el)))}
                            />
                        );
                    }
                    default:
                    // return <div> unknown component </div>;
                }
            })}
        </div>
    );
});

export default Filters;
